<template>
    <div id="report-agent-performance">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.chatResolveTimeByAgent') }}</h2>
                    </div>
                    <ResolveTimeByUser
                        :title="$t('report.chatResolveTimeByAgent')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.resolveTime"
                    />
                </div>
                <a-divider />
                <div class="chart-section">
                    <div class="title">
                        <ChartDoddleIcon />
                        <h2>{{ $t('report.firstAnswerByAgent') }}</h2>
                    </div>
                    <FirstInteractionTimeByUser
                        :title="$t('report.firstAnswerByAgent')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.firstInteraction"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import ResolveTimeByUser from "./ResolveTimeByUser.vue";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import FirstInteractionTimeByUser from "./FirstInteractionTimeByUser.vue";

const log = log2("AgentPerformance");
export default {
    name: "AgentPerformance",
    components: {
        FirstInteractionTimeByUser,
        ChartDoddleIcon,
        ResolveTimeByUser,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                firstInteraction: null,
                resolveTime: null,
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.agentPerformanceAll(this.filters)
                .then((res) => {
                    log("agentPerformanceAll data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-agent-performance {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .title {
                    display: flex;
                    gap: 4px;
                    align-items: center;

                    justify-content: center;

                    h2 {
                        text-align: center;
                        font-weight: 700;
                        font-size: 40px;
                        margin: 0 !important;
                    }
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
